import {AppConfigService} from './app-config.service';
import {Partner} from './app-models/models';
import {Headers} from '@angular/http';
import {HttpClientService} from './http-client.service';
import {Injectable} from '@angular/core';

@Injectable()
export class CreatePartnerService {

  private apiUrl = AppConfigService.settings.apiUrl + 'partners/';

  constructor(private http: HttpClientService) {
  }

  createPartner(data: Partner): Promise<Partner> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'create', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as Partner)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/create-partner.service.ts